var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabBarBox"},_vm._l((_vm.linkList),function(item,index){return _c('router-link',{key:index,class:_vm.curPath.includes(item.path) ? 'actClass' : '',attrs:{"to":item.path}},[_c('img',{attrs:{"src":`https://img.bbalt.cn/imgh5/menu_svg/tab_${item.icon}${
          _vm.curPath.includes(item.path) ? '_act' : ''
        }.svg`,"alt":""}}),_vm._v(" "+_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }